import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Table,
  Modal,
} from "reactstrap";
import _ from "lodash";
import { Field, reduxForm } from "redux-form";
import moment from "moment";
import "./styles.css";
import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import {
  MDBDataTable,
  MDBBtn,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdbreact";
import axios from "axios";
import Select from "react-select";
import DatePicker from "react-datepicker";
import MUIDataTable from "mui-datatables";
import "antd/dist/antd.css";
import { TimePicker } from "antd";
import "react-datepicker/dist/react-datepicker.css";
import {
  createMuiTheme,
  MuiThemeProvider,
  withStyles,
} from "@material-ui/core/styles";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import { faPlus, faMinus, faPen } from "@fortawesome/free-solid-svg-icons";
import Util from '../../../Common/util';
import API from '../../../Common/api';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';


var url = window.location.hostname;
var port = window.location.port;

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

function formatDate(date) {
    var d = new Date(date),
     month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    //handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  state = {
    orderTypes: [],
    userName: null,
    selectedLocation: null,
    cancelResponseData: [],
    pickingData: [],
    selected: {},
    selected_all: false,
    disableBtn: true,
    pickReqIds: [],
    loadingbtn: false,
    cancelModal: false,
    pick_type: "",
    ptl_id: "",
    lb_sku_id: "",
    pkd: "",
    from_date:"",
    to_date:"",
    showPickingCancelTable: false,
    respModal: false,
    respMsg: null,
    showCancelResponse: false,
  };



  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  
  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8099";
    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie("token");
    var Location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState(
      {
        userName: cookieUsername,
        selectedLocation: Location,
      }
    );
    localStorage.setItem("userName", username);
  }

  handleCheckBoxClick = (e) => {
    const selected = this.state.selected;
    selected[e.target.name] = e.target.checked;

    this.setState({ selected }, () => {
      var sp_checked_status = [];
      for (let pickReqId in this.state.selected) {
        if (this.state.selected[pickReqId] == true) {
          sp_checked_status.push(pickReqId);
        }
      }

      if (sp_checked_status.length > 0) {
        this.setState({
          disableBtn: false,
          pickReqIds: sp_checked_status,
        });
      } else {
        this.setState({
          disableBtn: true,
          pickReqIds: sp_checked_status,
        });
      }
    });
  };

  handleallCheckBoxClick = (e) => {
    const selected_all = e.target.checked;
    const selected = this.state.selected;

    const checkboxes = document.getElementsByClassName("checkbox_div");

    for (var i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].disabled == false) {
        if (checkboxes[i].checked != e.target.checked) {
          document.getElementsByName(checkboxes[i].name)[0].click();
        }
      }
    }

    this.setState(
      {
        selected: selected,
        selected_all: selected_all,
      },
      () => {
        var sp_checked_status = [];
        for (let pickReqId in this.state.selected) {
          if (this.state.selected[pickReqId] == true) {
            sp_checked_status.push(pickReqId);
          }
        }

        if (sp_checked_status.length > 0) {
          this.setState({
            disableBtn: false,
            pickReqIds: sp_checked_status,
          });
        } else {
          this.setState({
            disableBtn: true,
            pickReqIds: sp_checked_status,
          });
        }
      }
    );
  };
  

  ledgerLbskuIDChange = (e) =>{
	   
	if(e.target.name == "ptl_id"){
      this.setState({
        ptl_id :  e.target.value
      },() => {console.log(this.state.ptl_id)})  
    }
	
    if(e.target.name == "ptl_type"){
      this.setState({
        pick_type :  e.target.value
      })  
    }
	
	 if(e.target.name == "lbskuid"){
      this.setState({
        lbskuid :  e.target.value
      })  
    }
	if(e.target.name == "pkd"){
      this.setState({
        pkd :  e.target.value
      })  
    }
  }
  
  cancelPickingData = () => {
	if((this.state.ptl_id === "" || this.state.ptl_id === undefined) ||
            (this.state.pick_type === "" || this.state.pick_type === undefined)){
              alert("Select PTL Id or Pick Type filter");
              return false;
    }  
	var ledger_fromdate = "";
	var ledger_todate = ""
	if(this.state.ledger_fromdate != "" && this.state.ledger_fromdate != undefined){
	    ledger_fromdate = formatDate(this.state.ledger_fromdate);  
	}
	if(this.state.ledger_todate != "" && this.state.ledger_todate != undefined){
	   ledger_todate = formatDate(this.state.ledger_todate);
	}
	
    const payload = {
      location: this.state.selectedLocation,
      pick_type: this.state.pick_type,
      ptl_id: this.state.ptl_id,
  lb_sku_id: this.state.lbskuid,
  pkd: this.state.pkd,
  from_date:ledger_fromdate,
  to_date:ledger_todate
  };
   addAnalytics('Picking Cancellation', 'Picking Cancellation Filter', payload);

API.post('/picking/fetchPickingCancel/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        //console.log(data);

        let pickingData = [];
        for (let i = 0; i < data.length; i++) {
          let row = data[i];
          if (row["cancel_eligible"] === false) {
            var checkbox_html = "";
          } else {
            var checkbox_classname =
              "checkbox_div checkbox_" + row["picking_request_id"];
            var checkbox_html = (
              <input
                type="checkbox"
                name={row["picking_request_id"]}
                selected={this.state.selected[checkbox_classname]}
                className={checkbox_classname}
                onChange={this.handleCheckBoxClick}
              />
            );
          }
          
          let lineData = {
            checkbox: checkbox_html,
            ptl_id: row["ptl_id"],
            pick_type: row["pick_type"],
            lb_sku_id: row["lb_sku_id"],
            pkd: row["pkd"],
            total_qty: row["total_qty"],
            icld_qty: row["icld_qty"],
            loose_qty: row["loose_qty"],
            tester_qty: row["tester_qty"],
          };
          pickingData.push(lineData);
        }

        this.setState({
          pickingData: pickingData,
          showPickingCancelTable: true,
        });
      })
      .catch(function (error) {});
  };

  beforeCancel = () => {
    this.setState({
		cancelModal: !this.state.cancelModal,
	});
  }

  respModalToggle = () => {
    this.setState({
		respModal: !this.state.respModal,
        cancelModal: false,
	}, () => {/*window.location.reload()*/});  
  }
  cancelUpdate = () => {
    const payload = {
      location: this.state.selectedLocation,
		  picking_request_ids: this.state.pickReqIds
  };
   addAnalytics('Picking Cancellation', 'Cancel Picksheet', payload);

API.post('/picking/pickingRequestCancel/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
          console.log("Data",data)
          console.log(data.data);
         
           this.setState({
                cancelModal: false,
				        respModal: true,
                respMsg: data.reason, 
                showCancelResponse: true,
                cancelResponseData: data,
                showPickingCancelTable: false     
			});
         
      })
      .catch(function (error) {});
  };
  render() {
    const UploadTableHeader = [
      {
        label: (
          <input
            type="checkbox"
            onChange={this.handleallCheckBoxClick}
            selected={false}
          />
        ),
        name: "checkbox",
      },
      {
        label: "PTL Id",

        field: "ptl_id",
        sort: "asc",
        width: 180,
      },
      {
        label: "Pick Type",

        field: "pick_type",
        sort: "asc",
        width: 150,
      },
      {
        label: "LBSKUID",

        field: "lb_sku_id",
        sort: "asc",
        width: 230,
      },
      {
        label: "PKD",

        field: "pkd",
        sort: "asc",
        width: 100,
      },
      {
        label: "Total Qty",

        field: "total_qty",
        sort: "asc",
        width: 100,
      },
      {
        label: "ICLD Qty",

        field: "icld_qty",
        sort: "asc",
        width: 100,
      },
      {
        label: "Loose Qty",

        field: "loose_qty",
        sort: "asc",
        width: 100,
      },
      {
        label: "Tester Qty",

        field: "tester_qty",
        sort: "asc",
        width: 100,
      },
    ];

    const pickingTableData = {
      columns: UploadTableHeader,
      rows: this.state.pickingData,
    };
    return (
      <Col xl={12}>
        <Card>
          <CardBody>
            <div className="form__form-group col-xl-2" style={{display: 'inline-flex',marginBottom:'0px'}}>
                <div className="form__form-group-field" style={{display: 'contents'}}>

				<input  style={{height: 38,width:"100%",border:'1px solid #bfbfbf'}}
                    name="ptl_id"
                    type="text"
                    placeholder="PTL Id"
                    id="ptd_id" 
                    onChange={this.ledgerLbskuIDChange} 
                  />
				</div>
              </div>
            
			  <div className="form__form-group col-xl-2" style={{display: 'inline-flex',marginBottom:'0px'}}>
               
                <div className="form__form-group-field" style={{display: 'contents'}}>

				                  
				  <select
                    className="form-control"
					id="ptl_type"
					name="ptl_type"
                    style={{ fontSize: 13,borderRadius: 0 ,border:'1px solid #bfbfbf'}}
                    value={this.state.selectedPickType}
                    onChange={this.ledgerLbskuIDChange} 
                  >
				  <option value="0" >Select Pick Type</option>
                  <option value="icld">ICLD</option>
					<option value="loose" dis>Loose</option>
					<option value="tester" dis>Tester</option>
					<option value="outer" dis>Outer</option>
					
				  </select>
				  
				</div>
              </div>
            <div className="form__form-group col-xl-2" style={{display: 'inline-flex',marginBottom:'0px'}}>
                <div className="form__form-group-field" style={{display: 'contents'}}>

				<input  style={{height: 38,width:"100%",border:'1px solid #bfbfbf'}}
                    name="lbskuid"
                    type="text"
                    placeholder="LBSKUID"
                    id="lbskuid" 
                    onChange={this.ledgerLbskuIDChange} 
                  />
				</div>
              </div>
			  <div className="form__form-group col-xl-1" style={{display: 'inline-flex',marginBottom:'0px'}}>
                <div className="form__form-group-field" style={{display: 'contents'}}>

				<input  style={{height: 38,width:"100%",border:'1px solid #bfbfbf'}}
                    name="pkd"
                    type="text"
                    placeholder="PKD"
                    id="pkd" 
                    onChange={this.ledgerLbskuIDChange} 
                  />
				</div>
              </div>
			  
			  <div className="form__form-group col-xl-2" style={{display: 'inline-block',width:'100%',marginBottom:'0px'}}>
                
					<DatePicker
                    selected={this.state.ledger_fromdate}
                    onChange={this.ledgerFromDateChange}
                    className="ledger_fromdate"
					placeholderText="From Date"
                    format='yyyy-MM-dd'
					style={{border:'1px solid #bfbfbf', width:'100%'}}
                  />
              </div>
			  <div className="form__form-group col-xl-2" style={{display: 'inline-block',width:'100%',marginBottom:'0px'}}>
				<DatePicker 
                    selected={this.state.ledger_todate}
                    onChange={this.ledgerToDateChange}
                    className="ledger_todate"
					placeholderText="To Date"
					style={{border:'1px solid #bfbfbf', width:'100%'}}
                />
              </div>

            <div
              className="form__form-group col-xl-1"
              style={{
                display: "inline-block",
                width: "100%",
                marginBottom: "0px",
              }}
            >
              <ButtonToolbar className="form__button-toolbar">
                <button
                  color="primary"
                  className="btn-sm button_enable "
                  style={{
                    borderRadius: 5,
                    backgroundColor: "#70bbfd",
                    color: "#fff",
                  }}
                  id="button_enable"
                  onClick={this.cancelPickingData}
                >
                  Submit
                </button>
              </ButtonToolbar>
            </div>
          </CardBody>

          {this.state.showPickingCancelTable &&
          <CardBody style={{ marginTop: 20 }}>
            <button
              color="primary"
              disabled={this.state.disableBtn}
              className={
                this.state.editBtnFlag
                  ? "btn btn-primary btn-sm"
                  : "btn btn-primary btn-sm isDisabled"
              }
              style={{ margin: "15px 0px", textTransform: "capitalize" }}
              onClick={this.beforeCancel}
              type="submit"
            >
              {this.state.loadingbtn && (
                <i
                  className="fa fa-refresh fa-spin"
                  style={{ marginRight: "5px" }}
                />
              )}
              Cancel Task
            </button>
            <MDBDataTable
              striped
              bordered
              hover
              scrollY
              scrollX
              paging={true}
              searching={true}
              onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'Picking_cancellation_pagination', 'datatable_pagination_change' )}
              data={pickingTableData}
              scrollX={true}
            ></MDBDataTable>
          </CardBody>
		  }


        {this.state.showCancelResponse && (
            <CardBody style={{ marginTop: 20 }}>
             
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>Picking Id</th>
                    <th>Response</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.cancelResponseData.length >
                    0 &&
                    this.state.cancelResponseData.map(
                      (item, index) => (
                        <tr>
                          <td>{item.picking_request_id}</td>
                          <td style={{ color: "red" }}>{item.reason}</td>
                        </tr>
                      )
                    )}

                  
                </tbody>
              </Table>
            </CardBody>
          )}


        </Card>

        <Modal isOpen={this.state.cancelModal} toggle={this.beforeCancel}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.beforeCancel}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-checkmark-circle modal__title-icon"
              style={{ color: "green" }}
            />
            <h4>Are you sure want to Cancel?</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#ccc" }}
              className="modal_cancel"
              onClick={this.beforeCancel}
            >
              Cancel
            </Button>

            <Button
              style={{
                backgroundColor: "#24d6a3",
                color: "#fff",
                marginLeft: "20px",
              }}
              className="modal_ok"
              onClick={this.cancelUpdate}
            >
              Confirm
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={this.state.respModal} toggle={this.respModalToggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.respModalToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-checkmark-circle modal__title-icon"
              style={{ color: "green" }}
            />
            <h4>Successfully Updated</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#ccc" }}
              className="modal_cancel"
              onClick={this.respModalToggle}
            >
              OK
            </Button>
          </ButtonToolbar>
        </Modal>
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));